// extracted by mini-css-extract-plugin
export var subtitle = "_6j-2";
export var title = "_6j-0";
export var titleNoWrap = "_6j-1";